import { ShapeRenderer, type ShapeSpec } from "./ShapeRenderer";

export function SequenceRenderer({ visualSpec, shapeMode = false }: { visualSpec: Record<string, unknown>; shapeMode?: boolean }) {
  const items = (Array.isArray(visualSpec.sequence) ? visualSpec.sequence : visualSpec.items ?? []) as unknown[];

  return (
    <div className="flex w-full flex-wrap items-center justify-start gap-3 rounded-lg border border-white/10 bg-slate-950/35 p-4 sm:justify-center">
      {items.map((item, index) => (
        <div key={index} className="flex min-h-14 min-w-14 items-center justify-center rounded-lg border border-white/10 bg-white/[0.045] px-3 text-xl font-bold text-cyan-100">
          {shapeMode || typeof item === "object" ? <ShapeRenderer spec={item as ShapeSpec} /> : String(item)}
        </div>
      ))}
    </div>
  );
}
